import { useEffect, useState } from 'react';

const EMPTY = {
  clave: '',
  nombre: '',
  horaInicio: '',
  horaFin: '',
  horaComidaInicio: '',
  horaComidaFin: '',
  descripcion: '',
  activo: true,
};

export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({
    clave: '',
    nombre: '',
    horaInicio: '',
    horaFin: '',
    horaComidaInicio: '',
    horaComidaFin: '',
    descripcion: '',
  });

  const validateForm = (updatedForm) => {
    let newErrors = { clave: '', nombre: '', horaInicio: '', horaFin: '', horaComidaInicio: '', horaComidaFin: '', descripcion: '' };
    let isValid = true;

    const check = (field, errorMsg) => {
      newErrors[field] = errorMsg;
      if (errorMsg) isValid = false;
    };

    const tToM = (t) => {
      if (!t) return null;
      const [h, m] = t.split(':').map(Number);
      return h * 60 + m;
    };

    const vClave = updatedForm.clave?.trim();
    if (!vClave) check('clave', 'La clave es obligatoria.');

    const vNombre = updatedForm.nombre?.trim();
    if (!vNombre) check('nombre', 'El nombre es obligatorio.');

    const vDesc = updatedForm.descripcion?.trim();
    if (!vDesc) check('descripcion', 'La descripción es obligatoria.');

    const mInicio = tToM(updatedForm.horaInicio);
    const mFin = tToM(updatedForm.horaFin);
    const mcInicio = tToM(updatedForm.horaComidaInicio);
    const mcFin = tToM(updatedForm.horaComidaFin);

    if (mInicio === null) check('horaInicio', 'Requerido.');
    if (mFin === null) check('horaFin', 'Requerido.');
    
    if (mInicio !== null && mFin !== null) {
      if (mFin - mInicio < 60) {
        check('horaFin', 'El turno debe durar al menos 1 hora.');
        check('horaInicio', 'El turno debe durar al menos 1 hora.');
      }
    }

    if (mcInicio === null) check('horaComidaInicio', 'Requerido.');
    if (mcFin === null) check('horaComidaFin', 'Requerido.');

    if (mcInicio !== null && mcFin !== null) {
      if (mcFin - mcInicio < 15) {
        check('horaComidaFin', 'Mínimo 15 min.');
        check('horaComidaInicio', 'Mínimo 15 min.');
      }
    }

    if (mInicio !== null && mFin !== null && mcInicio !== null && mcFin !== null) {
      if (mcInicio < mInicio || mcInicio > mFin) {
        check('horaComidaInicio', 'Debe estar dentro del turno.');
      }
      if (mcFin < mInicio || mcFin > mFin) {
        check('horaComidaFin', 'Debe estar dentro del turno.');
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const validateAll = () => {
    return validateForm(form);
  };

  const handleChange = (field, value) => {
    const updatedForm = { ...form, [field]: value };
    setForm(updatedForm);
    validateForm(updatedForm);
  };

  useEffect(() => {
    if (mode === 'edit' && data) {
      const filled = {
        idTurno: data.idTurno ?? 0,
        clave: data.clave ?? '',
        nombre: data.nombre ?? '',
        horaInicio: data.horaInicio ?? '',
        horaFin: data.horaFin ?? '',
        horaComidaInicio: data.horaComidaInicio ?? '',
        horaComidaFin: data.horaComidaFin ?? '',
        descripcion: data.descripcion ?? '',
        idEmpresa: data.idEmpresa ?? 0,
        activo: data.activo ?? true,
      };
      setForm(filled);
      validateForm(filled);
    } else {
      setForm({ ...EMPTY });
      setErrors({ clave: '', nombre: '', horaInicio: '', horaFin: '', horaComidaInicio: '', horaComidaFin: '', descripcion: '' });
    }
  }, [mode, data]);

  if (!open) return null;

  const hasErrors = Object.values(errors).some((e) => !!e);
  const isSaveDisabled = !form.clave?.trim() || !form.nombre?.trim() || !form.horaInicio || !form.horaFin || !form.horaComidaInicio || !form.horaComidaFin || !form.descripcion?.trim() || hasErrors;

  const errorStyle = {
    color: '#b91c1c',
    fontSize: '.8rem',
    display: 'block',
    marginTop: '4px',
  };

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nuevo turno' : 'Editar turno'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '12%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Clave:</label>
        <br /><br />
        <input
          className={`infoField${errors.clave ? ' infoField--error' : ''}`}
          value={form.clave}
          onChange={(e) => handleChange('clave', e.target.value)}
          maxLength={50}
        />
        {errors.clave && <small style={errorStyle}>{errors.clave}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Nombre:</label>
        <br /><br />
        <input
          className={`infoField${errors.nombre ? ' infoField--error' : ''}`}
          value={form.nombre}
          onChange={(e) => handleChange('nombre', e.target.value)}
          maxLength={150}
        />
        {errors.nombre && <small style={errorStyle}>{errors.nombre}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Hora inicio:</label>
        <br /><br />
        <input
          className={`infoField${errors.horaInicio ? ' infoField--error' : ''}`}
          type="time"
          onKeyDown={(e) => e.preventDefault()}
          value={form.horaInicio}
          onChange={(e) => handleChange('horaInicio', e.target.value)}
          onBlur={() => validateForm(form)}
        />
        {errors.horaInicio && <small style={errorStyle}>{errors.horaInicio}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Hora fin:</label>
        <br /><br />
        <input
          className={`infoField${errors.horaFin ? ' infoField--error' : ''}`}
          type="time"
          onKeyDown={(e) => e.preventDefault()}
          value={form.horaFin}
          onChange={(e) => handleChange('horaFin', e.target.value)}
          onBlur={() => validateForm(form)}
        />
        {errors.horaFin && <small style={errorStyle}>{errors.horaFin}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Hora comida inicio:</label>
        <br /><br />
        <input
          className={`infoField${errors.horaComidaInicio ? ' infoField--error' : ''}`}
          type="time"
          onKeyDown={(e) => e.preventDefault()}
          value={form.horaComidaInicio}
          onChange={(e) => handleChange('horaComidaInicio', e.target.value)}
          onBlur={() => validateForm(form)}
        />
        {errors.horaComidaInicio && <small style={errorStyle}>{errors.horaComidaInicio}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Hora comida fin:</label>
        <br /><br />
        <input
          className={`infoField${errors.horaComidaFin ? ' infoField--error' : ''}`}
          type="time"
          onKeyDown={(e) => e.preventDefault()}
          value={form.horaComidaFin}
          onChange={(e) => handleChange('horaComidaFin', e.target.value)}
          onBlur={() => validateForm(form)}
        />
        {errors.horaComidaFin && <small style={errorStyle}>{errors.horaComidaFin}</small>}
      </div>

      <div style={{ gridColumn: '1 / 2' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Descripción:</label>
        <br /><br />
        <textarea
          className={`infoField${errors.descripcion ? ' infoField--error' : ''}`}
          value={form.descripcion}
          onChange={(e) => handleChange('descripcion', e.target.value)}
          rows={3}
          maxLength={500}
        />
        {errors.descripcion && <small style={errorStyle}>{errors.descripcion}</small>}
      </div>

      {/* idEmpresa se inyecta automáticamente desde la sesión */}

      {/* 👇 Se eliminó el checkbox de "Activo" de la UI,
          pero form.activo sigue existiendo y se manda en onSubmit */}
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => {
          if (validateAll()) onSubmit(form, mode);
        }}
        disabled={isSaveDisabled}
        style={{
          opacity: isSaveDisabled ? 0.5 : 1,
          cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(900px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
